import * as React from 'react'

function SvgIconHashtag(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g id="hashtag" aria-labelledby="t-hashtag d-hashtag">
        <title id="t-hashtag">{'Hashtag'}</title>
        <desc id="d-hashtag">{'Number symbol or hash character'}</desc>
        <path d="M25.2 10h-3.4L23 1.1c.1-.5-.3-1.1-.9-1.1-.6-.1-1 .3-1.1.9L19.8 10h-6L15 1.1c.1-.5-.3-1.1-.9-1.1-.5-.1-1.1.3-1.1.9L11.8 10H8.2c-.6 0-1 .4-1 1s.4 1 1 1h3.4l-1.1 8H6.8c-.6 0-1 .4-1 1s.4 1 1 1h3.4L9 30.9c-.1.5.3 1.1.9 1.1.6.1 1-.3 1.1-.9l1.2-9.1h6L17 30.9c-.1.5.3 1.1.9 1.1.5.1 1.1-.3 1.1-.9l1.2-9.1h3.6c.601 0 1-.4 1-1s-.399-1-1-1h-3.4l1.1-8h3.6c.604 0 1-.4 1-1s-.4-1-.9-1zm-6.7 10h-6l1.1-8h6l-1.1 8z" />
      </g>
    </svg>
  )
}

export default SvgIconHashtag
